import './businessList.css'
import BusinessListBanner from './businessList.banner'
import React, { useEffect, useRef, useState } from 'react'
import Search from '../search'
import BusinessFilters from './businessFilters'
import loadingImage from '../../assets/icons/loading.gif'
import CountriesFetch from '../api/countries.fetch'
import BusinessCategoriesFetch from '../api/businessCategories.fetch'
import BusinessTypesFetch from '../api/businessTypes.fetch'
import Results from './BusinessList.results'
import i18n from '../../i18n.js'
import { ENV_URL } from '../../app/constants'
import cookie from "react-cookies";

export default function BusinessList(props) {
    const { language, marketPlaceType } = (props = props)

    const [filter, setFilter] = useState(false)
    const [action, setAction] = useState('MOSTRAR')

    const [businessList, setBusinessList] = useState(null)
    const [data, setData] = useState(null)
    const [countries, setCountries] = useState(null)
    const [minManualQuotationPrice, setMinManualQuotationPrice] = useState(0)
    const [maxManualQuotationPrice, setMaxManualQuotationPrice] = useState(1)

    const [loading, setLoading] = useState(true)
    const [infoFetch, setInfoFetch] = useState(false)
    const [businessCategories, setBusinessCategories] = useState(null)
    const [businessTypes, setBusinessTypes] = useState(null)

    const [categoryFilterSelected, setCategoryFilterSelected] = useState()
    const [marketplaceTypeSelected, setMarketplaceTypeSelected] = useState()
    const [manualQuotationPriceFilterSelected, setManualQuotationPriceFilterSelected] = useState()
    const [currentPageSelected, setCurrentPageSelected] = useState()
    const [orderSelected, setOrderSelected] = useState()
    const [countrySelected, setCountrySelected] = useState();
    const [search, setSearch] =  useState();
    const [manualQuotationPrice, setManualQuotationPrice] = useState(0); //value for sql query
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [resetFormCookie, setResetFormCookie] = useState();
    const [isReseted, setIsReseted] = useState(false);
    const [countryDropdown, setCountryDropdown] = useState();
    const [searchTextValue, setSearchTextValue] = useState("");
    const [intermediationFilterSelected, setIntermediationFilterSelected] = useState()

    useEffect(() => {
        const marketPlaceTypeFromUrl = marketPlaceType || cookie.load('sdt_marketplace_type') || '*';
        const categoryFilter = cookie.load('sdt_marketplace_category') || '*';
        const manualQuotationPriceFilter = cookie.load('sdt_manual_quotation_price') || '*';
        const order = cookie.load('sdt_order_by') || 'new';
        const currentPage = cookie.load('sdt_current_business_list_page') || 1;
        const searchText = cookie.load('sdt_search_text') || '*';
        const countryId = cookie.load('sdt_country') || '*';
        const keepManualQuotationPrice = cookie.load('sdt_keep_manual_quotation_price');
        const mustReset = cookie.load('sdt_reset_form')
        const intermediationFilter = cookie.load('sdt_marketplace_intermediation') || '*';

        let isMobile = handleMobile()
        setFilter(!isMobile)
        setMarketplaceTypeSelected(marketPlaceTypeFromUrl === undefined || marketPlaceTypeFromUrl === '*' ? '*' : parseInt(marketPlaceTypeFromUrl));
        setCategoryFilterSelected(categoryFilter === undefined || categoryFilter === '*' ? '*' : parseInt(categoryFilter));
        setManualQuotationPriceFilterSelected(manualQuotationPriceFilter === undefined || manualQuotationPriceFilter === '*' ? '*' : parseInt(manualQuotationPriceFilter));
        setOrderSelected(order === undefined  ? 'new' : order);
        setCurrentPageSelected(currentPage === undefined ? 1 : parseInt(currentPage));
        setCountrySelected(countryId === undefined ? '*' : countryId);
        setSearch(searchText === undefined ? '*' : searchText);
        setManualQuotationPrice(keepManualQuotationPrice ? parseInt(manualQuotationPriceFilter) : maxManualQuotationPrice);
        setResetFormCookie(mustReset === undefined ? false : mustReset);
        setIntermediationFilterSelected(intermediationFilter === undefined || intermediationFilter === '*' ? '*' : parseInt(intermediationFilter));

        setIsSubmitted(true); // Trigger de fetchFilteredData cuando todo esté cargado
    }, [])

    useEffect(() => {
        if (marketplaceTypeSelected !== undefined) {
            cookie.save('sdt_marketplace_type', marketplaceTypeSelected, {path: '/'})
        }
    }, [marketplaceTypeSelected])

    useEffect(() => {
        if (categoryFilterSelected !== undefined) {
            cookie.save('sdt_marketplace_category', categoryFilterSelected, {path: '/'})
        }
    }, [categoryFilterSelected])

    useEffect(() => {
        if (manualQuotationPriceFilterSelected !== undefined) {
            cookie.save('sdt_manual_quotation_price', manualQuotationPriceFilterSelected, {path: '/'})
            if (manualQuotationPriceFilterSelected !== '*') {
                setManualQuotationPrice(manualQuotationPriceFilterSelected)
            } else {
                setManualQuotationPrice(maxManualQuotationPrice)
            }
        }
    }, [manualQuotationPriceFilterSelected])

    useEffect(() => {
        if (orderSelected !== undefined) {
            cookie.save('sdt_order_by', orderSelected, {path: '/'})
        }
    }, [orderSelected])

    useEffect(() => {
        if (currentPageSelected !== undefined) {
            cookie.save('sdt_current_business_list_page', currentPageSelected, {path: '/'})
        }
    }, [currentPageSelected])

    useEffect(() => {
        if (countrySelected !== undefined) {
            cookie.save('sdt_country', countrySelected, {path: '/'})
            setCountryDropdown(countrySelected)
        }
    }, [countrySelected])

    useEffect(() => {
        if (search !== undefined) {
            cookie.save('sdt_search_text', search, {path: '/'})
            if (search === '*') {
                setSearchTextValue('')
            } else {
                setSearchTextValue(search)
            }
        }
    }, [search])

    useEffect(() => {
        if (resetFormCookie !== undefined) {
        cookie.save('sdt_reset_form', resetFormCookie)
        }
    }, [resetFormCookie])

    useEffect(() => {
        if (intermediationFilterSelected !== undefined) {
            cookie.save('sdt_marketplace_intermediation', intermediationFilterSelected, {path: '/'})
        }
    }, [intermediationFilterSelected])

    /**
     * Sets isMobile state according to screen width to hide or display filters
     */
    const handleMobile = () => {
        return window.innerWidth < 600
    }

    const resultRef = useRef()
    const mobileResultRef = useRef()
    const searchScroll = () => {
        if (handleMobile()) {
            mobileResultRef.current.scrollIntoView({ behavior: 'smooth' })
            window.scrollBy(0, -180)
        } else {
            resultRef.current.scrollIntoView({ behavior: 'smooth' })
            window.scrollBy(0, -200)
        }
    }

    /**
     * Toggle filters display visibility
     */
    const toggleFilter = () => {
        setFilter(!filter)
        if (filter) {
            setAction('MOSTRAR')
        } else {
            setAction('OCULTAR')
        }
    }

    /**
     * Gets select value and sorts data array with businesses
     * @param event from select onChange
     */
    const orderBy = event => {
        let option = event.target.value
        setOrderSelected(option.toLowerCase())
        setCurrentPageSelected(1)
        setIsSubmitted(true);
    }

    /**
     * Fetchs data when url params change
     */
    useEffect(() => {
        let cookieReset = cookie.load('sdt_reset_form')
        let isReset = false;
        if (cookieReset !== undefined) {
            isReset = cookieReset
        }

        if ((isSubmitted || (!isSubmitted && isReset)) && marketplaceTypeSelected !== undefined && categoryFilterSelected !== undefined && manualQuotationPriceFilterSelected !== undefined && orderSelected !== undefined && countrySelected !== undefined && search !== undefined && currentPageSelected !== undefined && intermediationFilterSelected !== undefined) {
            fetchFilteredData();
            setIsSubmitted(false);
            setResetFormCookie(false)
        }
    }, [isSubmitted, isReseted, marketplaceTypeSelected, categoryFilterSelected, manualQuotationPriceFilterSelected, orderSelected, countrySelected, search, currentPageSelected, intermediationFilterSelected])

    const fetchFilteredData = async () => {
        setLoading(true)
        searchScroll()
        setBusinessList(null)

        let url
        url =
            `${ENV_URL}/api/V1/business/findBy/filter/` +
            search +
            '/' +
            countrySelected +
            '/' +
            categoryFilterSelected +
            '/' +
            marketplaceTypeSelected +
            '/' +
            intermediationFilterSelected +
            '/' +
            manualQuotationPriceFilterSelected +
            '/' +
            orderSelected +
            '?page=' +
            currentPageSelected

        const api = await fetch(url)

        if (api.status === 200) {
            const dataApi = await api.json()
            setBusinessList(dataApi.businesses)
            setMinManualQuotationPrice(dataApi.minManualQuotationPrice)
            setMaxManualQuotationPrice(dataApi.maxManualQuotationPrice)
            return true
        } else {
            return false
        }
    }

    /**
     * Validates that all data is available
     */
    useEffect(() => {
        if (
            businessList &&
            businessCategories &&
            businessTypes &&
            countries
        ) {
            setInfoFetch(true)
            setData(businessList.data)
            setLoading(false)
        }
    }, [
        businessList,
        businessCategories,
        businessTypes,
        countries,
    ])

    useEffect(() => {
        if (manualQuotationPriceFilterSelected === undefined || manualQuotationPriceFilterSelected === '*') {
            setManualQuotationPrice(maxManualQuotationPrice);
        }
    }, [maxManualQuotationPrice])

    return (
        <section className="businessList">
            <div className="businessList-section-content">
                <BusinessListBanner />

                <BusinessCategoriesFetch
                    setBusinessCategories={setBusinessCategories}
                />
                <BusinessTypesFetch setBusinessTypes={setBusinessTypes} />
                <CountriesFetch setCountries={setCountries} />

                <div className={'searchBar'} ref={resultRef}>
                    <Search language={language} setCurrentPageSelected={setCurrentPageSelected} setSearch={setSearch} country={countryDropdown} setCountry={setCountryDropdown} setIsSubmitted={setIsSubmitted} searchTextValue={searchTextValue} setSearchTextValue={setSearchTextValue} setCountrySelected={setCountrySelected} fromHome={ false } />
                </div>
                <div className="results container">
                    <div className="top d-md-flex justify-content-between">
                        <p>{i18n.t('business.list.text')}</p>

                        <div className={'sort'}>
                            <select onChange={orderBy}>
                                <option value={'NEW'} selected={orderSelected === 'new'}>
                                    {i18n.t('business.list.value1')}
                                </option>
                                <option value={'OLD'} selected={orderSelected === 'old'}>
                                    {i18n.t('business.list.value2')}
                                </option>
                                <option value={'DOWN'} selected={orderSelected === 'down'}>
                                    {i18n.t('business.list.value3')}
                                </option>
                                <option value={'UP'} selected={orderSelected === 'up'}>
                                    {i18n.t('business.list.value4')}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-5 col-lg-4">
                            <div className="toggle-button d-block d-md-none">
                                <button
                                    className="g-action-button-outline rounded-pill w-100"
                                    onClick={toggleFilter}
                                >
                                    {action} {i18n.t('business.list.button')}
                                </button>
                            </div>

                            {filter && (
                                <BusinessFilters
                                    infoFetch={infoFetch}
                                    businessCategories={businessCategories}
                                    businessTypes={businessTypes}
                                    countries={countries}
                                    maxManualQuotationPrice={maxManualQuotationPrice}
                                    minManualQuotationPrice={minManualQuotationPrice}
                                    marketplaceTypeSelected={marketplaceTypeSelected}
                                    setMarketplaceTypeSelected={setMarketplaceTypeSelected}
                                    setCategoryFilterSelected={setCategoryFilterSelected}
                                    categoryFilterSelected = {categoryFilterSelected}
                                    setManualQuotationPriceFilterSelected={setManualQuotationPriceFilterSelected}
                                    language={language}
                                    setCurrentPageSelected={setCurrentPageSelected}
                                    manualQuotationPrice={manualQuotationPrice}
                                    setManualQuotationPrice={setManualQuotationPrice}
                                    setIsSubmitted={setIsSubmitted}
                                    setSearch={setSearch}
                                    setCountrySelected={setCountrySelected}
                                    manualQuotationPriceFilterSelected={manualQuotationPriceFilterSelected}
                                    setResetFormCookie={setResetFormCookie}
                                    intermediationFilterSelected={intermediationFilterSelected}
                                    setIntermediationFilterSelected={setIntermediationFilterSelected}
                                />
                            )}
                        </div>
                        <div
                            ref={mobileResultRef}
                            className="col-12 col-md-7 col-lg-8"
                        >
                            {loading && (
                                <div className={'text-center'}>
                                    <img src={loadingImage} alt={'loading'} />
                                    <p>{i18n.t("contact-us.form.placeholders.loading")}</p>
                                </div>
                            )}

                            {!loading && infoFetch ? (
                                <Results
                                    businessList={businessList}
                                    currentPageSelected={currentPageSelected}
                                    setCurrentPageSelected={setCurrentPageSelected}
                                    data={data}
                                    language={language}
                                    setIsSubmitted={setIsSubmitted}
                                />
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
